import StatisticsLoader from '../../core/StatisticsLoader';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import TitledPanel from '../../core/TitledPanel';
import React from 'react';
import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { globalStyles as styles } from '../../core/style/gstheme';

class CollectionStatistics extends React.Component {

    displayView = (data) => {

        const classes = this.props.classes;

        return <Grid container spacing={2} classes={
            {
                "spacing-xs-2": this.props.classes.fullGrid
            }
        }>
            <Grid item xs={6} lg={4}>
                <TitledPanel fontSize="large" title="Basic Statistics">
                    {data.find(stat => stat.type === "https://grafsync.graphifi.com/schema/vm-skos-view/ConceptCount") &&
                        <div>
                            <Typography className={classes.subSubHeading}>Member Count</Typography>
                            <Typography data-test="member-count" className={classes.statistic}>
                                {data.find(stat => stat.type === "https://grafsync.graphifi.com/schema/vm-skos-view/ConceptCount").viewCount}
                            </Typography>
                        </div>
                    }
                </TitledPanel>
            </Grid>
        </Grid>;
    };

    render() {

        let exportNames = this.props.ordered ? ["collectionstatistics"] : ["unorderedcollectionstatistics"];

        return (
            <StatisticsLoader
                component={this.props.id}
                graph={this.props.graph}
                displayView={this.displayView}
                exportNames={exportNames}>
            </StatisticsLoader>
        );
    }

}

CollectionStatistics.propTypes = {
    classes: PropTypes.object,
    id: PropTypes.string.isRequired,
    ordered: PropTypes.bool.isRequired,
    graph: PropTypes.string.isRequired
};

export default withStyles(styles)(CollectionStatistics);